import Text from '@frontend/ui-kit/Components/Text';
import ContentSection from '@frontend/ui-kit/Components/ContentSection';
import BaseLayout from '../../../Components/shared/BaseLayout';
import ErrorContent from '../../../Components/Error/ErrorContent';
import {HTTP_CODE_NOT_FOUND} from '../../../constants';
import {gettext} from '../../../translationService';

const PageNotFound = () => {
    return (
        <BaseLayout>
            <ContentSection>
                <ErrorContent errorCode={HTTP_CODE_NOT_FOUND} title={gettext('Page Not Found')}>
                    <Text>
                        {gettext('Sorry, the page you\'re looking for cannot be found.')}
                    </Text>
                </ErrorContent>
            </ContentSection>
        </BaseLayout>
    );
};

export {PageNotFound as TestablePageNotFound};
export default PageNotFound;
